var version = {};
export {
  version as __exports
};
//# sourceMappingURL=version.js.map
